import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsThemesForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import cn from 'classnames';
import styles from './ReportingDetailsThemesEditTemplate.module.css';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface ReportingDetailsThemesEditTemplateProps {
  data: ThemeResponseDto;
  handleEditTheme: (theme: ThemeResponseDto) => void;
  handleOnChange: (theme: ThemeResponseDto) => void;
  handleImageOnChange: (ImageMeta: ImageMeta) => void;
  selectedLanguage: LocalesLanguagesConstants;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsThemesEditTemplate: FC<
  ReportingDetailsThemesEditTemplateProps
> = ({
  data,
  handleEditTheme,
  handleOnChange,
  handleImageOnChange,
  selectedLanguage,
  setLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Edit Theme" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/themes')}
          className={cn(styles.buttonLink)}
        >
          Go back to theme overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsThemesForm
        data={data}
        callbackFn={handleEditTheme}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsThemesEditTemplate;
